<template>
    <about-page />
</template>
<script>
    import { Component, Vue } from "vue-property-decorator";
    import AboutPage from '@/components/about/index.vue';

	@Component({
        components: {
            AboutPage
        }
    })
	export default class About extends Vue {
        
    }
</script>